'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _d = require('d3');

exports.default = function (container, scales, configuration) {
    return function (data) {
        var leftOffset = configuration.labelsWidth + configuration.labelsRightMargin;

        var dropLines = container.selectAll('.drop-line').data(data).enter().append('g').classed('drop-line', true).attr('width', scales.x.range()[1]).attr('transform', function (d, idx) {
            return 'translate(0, ' + scales.y(idx) + ')';
        }).attr('fill', configuration.eventLineColor);

        var drops = dropLines.selectAll('.drop');

        drops.data(function (d) {
            return d.data;
        }).enter().filter(function (d) {
            if (!d.shape) {
                return d;
            }
            return false;
        }).append('circle').classed('drop', true).attr('r', 5).attr('cx', function (d) {
            return scales.x(configuration.date(d));
        }).attr('cy', configuration.lineHeight / 2).attr('fill', configuration.eventColor).attr("data-id", function (d) {
            return d.id;
        }).on('mousedown', function (data, index, node) {
            return configuration.click(data, index, node, _d.event);
        }).on('dblclick', function (data, index, node) {
            return configuration.dblclick(data, index, node, _d.event);
        }).on('mouseover', function (data, index, node) {
            return configuration.mouseover(data, index, node, _d.event);
        }).on('mouseout', function (data, index, node) {
            return configuration.mouseout(data, index, node, _d.event);
        });

        // unregister previous event handlers to prevent from memory leaks
        drops.exit().on('mousedown', null).on('dblclick', null).on('mouseout', null).on('mouseover', null).remove();

        dropLines.exit().remove();
    };
};
//# sourceMappingURL=drops.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ansyn-event-drops/dist-es5/drawer/drops.js
// module id = ../../../../ansyn-event-drops/dist-es5/drawer/drops.js
// module chunks = vendor